import { CONFERENCE_WILL_LEAVE } from '../base/conference/actionTypes';
import ReducerRegistry from '../base/redux/ReducerRegistry';
import { CLEAR_VISITOR_PROMOTION_REQUEST, I_AM_VISITOR_MODE, SET_AUTO_PROMOTE_TOGGLE_ERROR, SET_AUTO_PROMOTE_TOGGLE_PENDING, SET_AUTO_PROMOTE_VISITORS, SET_I_AM_CHAT_SUSPENDED, SET_I_AM_HAND_BLOCKED, SET_PREJOIN_VISITORS_MODE, SET_RAISE_HAND_DISABLED_TOGGLE_ERROR, SET_RAISE_HAND_DISABLED_TOGGLE_PENDING, SET_ROLE_TRANSITION, SET_VISITORS_ENABLED, SET_VISITORS_RAISE_HAND_DISABLED, SET_VISITORS_ROSTER, SET_VISITORS_SUPPORTED, SET_VISITOR_CHAT_SUSPENDED, SET_VISITOR_DEMOTE_ACTOR, SET_VISITOR_HAND_BLOCKED, SET_VISITOR_MODE_TOGGLE_ERROR, SET_VISITOR_MODE_TOGGLE_PENDING, UPDATE_VISITORS_COUNT, VISITOR_JOINED, VISITOR_LEFT, VISITOR_PROMOTION_REQUEST } from './actionTypes';
const DEFAULT_STATE = {
    count: -1,
    iAmVisitor: false,
    showNotification: false,
    supported: false,
    promotionRequests: [],
    enabled: undefined,
    mode: undefined,
    updatedBy: undefined,
    updatedAt: undefined,
    togglePending: false,
    toggleError: undefined,
    requestedValue: undefined,
    requestedMode: undefined,
    autoPromote: undefined,
    autoPromotePending: false,
    autoPromoteError: undefined,
    autoPromoteRequestedValue: undefined,
    prejoinEnabled: undefined,
    prejoinPending: false,
    roster: [],
    suspendedChatVids: {},
    iAmHandBlocked: false,
    iAmChatSuspended: false,
    raiseHandDisabled: undefined,
    raiseHandDisabledPending: false,
    raiseHandDisabledError: undefined,
    raiseHandDisabledRequestedValue: undefined,
    roleTransition: undefined
};
ReducerRegistry.register('features/visitors', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case CONFERENCE_WILL_LEAVE: {
            const redirecting = Boolean(action.isRedirect);
            return Object.assign(Object.assign(Object.assign({}, state), DEFAULT_STATE), { 
                // A promotion or demotion leaves the current conference on purpose.
                // Keep the visitor flag and the loading screen across that leave;
                // a real hangup (isRedirect unset) clears both.
                iAmVisitor: redirecting ? state.iAmVisitor : DEFAULT_STATE.iAmVisitor, roleTransition: redirecting ? state.roleTransition : undefined });
        }
        case UPDATE_VISITORS_COUNT: {
            if (state.count === action.count) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { count: action.count });
        }
        case I_AM_VISITOR_MODE: {
            return Object.assign(Object.assign({}, state), { iAmVisitor: action.enabled, 
                // A promotion clears any moderator-imposed blocks on this visitor.
                iAmHandBlocked: action.enabled ? state.iAmHandBlocked : false, iAmChatSuspended: action.enabled ? state.iAmChatSuspended : false });
        }
        case SET_I_AM_HAND_BLOCKED: {
            return Object.assign(Object.assign({}, state), { iAmHandBlocked: action.on });
        }
        case SET_I_AM_CHAT_SUSPENDED: {
            return Object.assign(Object.assign({}, state), { iAmChatSuspended: action.on });
        }
        case SET_VISITORS_RAISE_HAND_DISABLED: {
            return Object.assign(Object.assign({}, state), { raiseHandDisabled: action.value, 
                // A confirmed metadata update settles any pending toggle.
                raiseHandDisabledPending: false, raiseHandDisabledError: undefined, raiseHandDisabledRequestedValue: undefined });
        }
        case SET_RAISE_HAND_DISABLED_TOGGLE_PENDING: {
            return Object.assign(Object.assign({}, state), { raiseHandDisabledPending: action.pending, raiseHandDisabledError: action.pending ? undefined : state.raiseHandDisabledError, raiseHandDisabledRequestedValue: action.pending ? action.requestedValue : undefined });
        }
        case SET_RAISE_HAND_DISABLED_TOGGLE_ERROR: {
            return Object.assign(Object.assign({}, state), { raiseHandDisabledError: action.error });
        }
        case SET_ROLE_TRANSITION: {
            return Object.assign(Object.assign({}, state), { roleTransition: action.transition });
        }
        case SET_VISITOR_DEMOTE_ACTOR: {
            return Object.assign(Object.assign({}, state), { demoteActorDisplayName: action.displayName });
        }
        case SET_VISITORS_SUPPORTED: {
            return Object.assign(Object.assign({}, state), { supported: action.value });
        }
        case SET_PREJOIN_VISITORS_MODE: {
            return Object.assign(Object.assign({}, state), { prejoinEnabled: action.enabled, prejoinPending: Boolean(action.pending) });
        }
        case SET_VISITORS_ENABLED: {
            return Object.assign(Object.assign({}, state), { enabled: action.enabled, mode: action.mode, updatedBy: action.updatedBy, updatedAt: action.updatedAt, 
                // A confirmed metadata update settles any pending toggle.
                togglePending: false, toggleError: undefined, requestedValue: undefined, requestedMode: undefined });
        }
        case SET_VISITOR_MODE_TOGGLE_PENDING: {
            return Object.assign(Object.assign({}, state), { togglePending: action.pending, toggleError: action.pending ? undefined : state.toggleError, requestedValue: action.pending ? action.requestedValue : undefined, requestedMode: action.pending ? action.requestedMode : undefined });
        }
        case SET_VISITOR_MODE_TOGGLE_ERROR: {
            return Object.assign(Object.assign({}, state), { toggleError: action.error });
        }
        case SET_AUTO_PROMOTE_VISITORS: {
            return Object.assign(Object.assign({}, state), { autoPromote: action.value, 
                // A confirmed metadata update settles any pending toggle.
                autoPromotePending: false, autoPromoteError: undefined, autoPromoteRequestedValue: undefined });
        }
        case SET_AUTO_PROMOTE_TOGGLE_PENDING: {
            return Object.assign(Object.assign({}, state), { autoPromotePending: action.pending, autoPromoteError: action.pending ? undefined : state.autoPromoteError, autoPromoteRequestedValue: action.pending ? action.requestedValue : undefined });
        }
        case SET_AUTO_PROMOTE_TOGGLE_ERROR: {
            return Object.assign(Object.assign({}, state), { autoPromoteError: action.error });
        }
        case SET_VISITOR_CHAT_SUSPENDED: {
            const suspendedChatVids = Object.assign({}, state.suspendedChatVids);
            if (action.on) {
                suspendedChatVids[action.vid] = true;
            }
            else {
                delete suspendedChatVids[action.vid];
            }
            return Object.assign(Object.assign({}, state), { suspendedChatVids });
        }
        case VISITOR_PROMOTION_REQUEST: {
            const currentRequests = state.promotionRequests || [];
            const promotionRequests = currentRequests.some(r => r.from === action.request.from)
                ? currentRequests.map(r => {
                    if (r.from === action.request.from) {
                        return action.request;
                    }
                    return r;
                })
                : [...currentRequests, action.request];
            return Object.assign(Object.assign({}, state), { promotionRequests });
        }
        case CLEAR_VISITOR_PROMOTION_REQUEST: {
            let currentRequests = state.promotionRequests || [];
            currentRequests = currentRequests.filter(r => r.from !== action.request.from);
            return Object.assign(Object.assign({}, state), { promotionRequests: currentRequests });
        }
        case SET_VISITORS_ROSTER: {
            return Object.assign(Object.assign({}, state), { roster: action.visitors });
        }
        case VISITOR_JOINED: {
            const roster = state.roster || [];
            const existing = roster.findIndex(v => v.vid === action.visitor.vid);
            if (existing >= 0) {
                const next = [...roster];
                next[existing] = action.visitor;
                return Object.assign(Object.assign({}, state), { roster: next });
            }
            return Object.assign(Object.assign({}, state), { roster: [...roster, action.visitor] });
        }
        case VISITOR_LEFT: {
            return Object.assign(Object.assign({}, state), { roster: (state.roster || []).filter(v => v.vid !== action.vid) });
        }
        case SET_VISITOR_HAND_BLOCKED: {
            return Object.assign(Object.assign({}, state), { roster: (state.roster || []).map(v => {
                    if (v.vid !== action.vid) {
                        return v;
                    }
                    return Object.assign(Object.assign({}, v), { handBlocked: action.on === true || undefined });
                }) });
        }
    }
    return state;
});
